import {useLocation, useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import {useEffect, useState} from "react";
import {STATUS_MODEL} from "../../../../../enums/statusEnum";
import {
    formatName,
    getIdentityValidationTypeById,
    IDENTITY_DOCUMENTS_MODEL,
    IDENTITY_VALIDATION_CARD_MODEL
} from "../../Visitor/Model/Model";
import {GetUserDetailForUpdate} from "../../../../../reduxToolkit/Contractor/ContractorApi";
import {VISITOR_MODEL} from "../../Model/Model";
import {GetAllUserFiles} from "../../../../../reduxToolkit/UserFile/UserFileApi";
import {GetInvitationById} from "../../../../../reduxToolkit/Invitation/InvitationApi";
import {toast} from "react-toastify";
import {DownloadDataZip, ZipDownloadByUserId} from "../../../../../reduxToolkit/fileUpload/FileUploadApi";
import {errorMsg, getFullName} from "../../../../../Apis/functions";
import {useTranslation} from "react-i18next";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */

export const IdentityVerificationApp = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();
    let { state } = location;
    const userId = state?.id;
    const backUrl = state?.backUrl;
    const invitationId = state?.backUrl?.state?.invitationId;
    const [item, setItem] = useState({...VISITOR_MODEL});
    const [showApprove, setShowApprove] = useState(false);
    const [showDenied, setShowDenied] = useState(false);
    const [modified, setModified] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [identityDocuments, setIdentityDocuments] = useState(null);
    const [assets, setAssets] = useState(null);
    const [identityValidationType, setIdentityValidationType] = useState(null);
    const [identityValidationStatus, setIdentityValidationStatus] = useState(null);

    // Generic modal configuration for approval/denial/comments
    const genericCommentModals = [
        {
            show: showApprove,
            setter: setShowApprove,
            title: 'approve_id_validation',
            description: 'you_can_leave_a_optional_comment',
            status: STATUS_MODEL.VALIDATED,
            required: false,
            successTrans:"has_been_validated_successfully"
        },
        {
            show: showDenied,
            setter: setShowDenied,
            title: 'decline_id_validation',
            description: 'please_provide_a_reason',
            status: STATUS_MODEL.DENIED,
            required: true,
            successTrans:"has_been_denied_successfully"
        },
    ];

    useEffect(() => {
        if(modified){
            getData();
            setModified(false);
        }
    }, [modified]);

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        dispatch(GetUserDetailForUpdate(userId)).then(({payload: {data: {data}}}) => {

            let aux = data;
            if (aux?.id) {
                setItem(VISITOR_MODEL.set(aux));
                setIdentityValidationType(getIdentityValidationTypeById(aux?.identityValidationType));
                setIdentityValidationStatus(IDENTITY_VALIDATION_CARD_MODEL.getIdentityValidationStatus(aux?.identityValidation?.id))
                dispatch(GetAllUserFiles(userId)).then(({payload: {data: {data}}}) => {
                    setIdentityDocuments(IDENTITY_DOCUMENTS_MODEL.set(data, aux));
                    setAssets(data);
                });
                getInvitationData();
            }
        });
    }

    const getInvitationData = () => {
        if(invitationId)
            dispatch(GetInvitationById(invitationId));
    }
    // Generate styles based on approval status


    const handleOnBack = () => {
        navigate(backUrl.pathname, {
            state: backUrl.state
        });
    }

    const handleDownload = () => {
        const assetsId = assets.map(asset => asset?.id);

        if (assetsId?.length <= 0) {
            toast.warn(t('no_files_registered'));
            return;
        }
        const nameZip = formatName(getFullName(item?.name, item?.lastName));
        dispatch(ZipDownloadByUserId(userId)).then(({ payload: { data, code } }) => {
            if (data) {
                DownloadDataZip(data, nameZip)
            } else {
                errorMsg(code)
            }
        })
    }

    const hasIdentityFiles = Object.values(assets || {}).some((item) => item?.file);


    return {
        item,
        setShowApprove,
        setShowDenied,
        disabled,
        identityDocuments,
        identityValidationType,
        identityValidationStatus,
        genericCommentModals,
        setModified,
        modified,
        userId,
        invitationId,
        handleOnBack,
        handleDownload,
        hasIdentityFiles
    };
}
